<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[process$, userInfo$, leaverequests$, tasks$, directReports$]"></ef-loading-container>
<ef-leave-request
    [process]="process$ | async"
    [leaverequests]="leaverequests$ | async"
    [tasks]="tasks$ | async"
    [payrollItems]="payrollItems$ | async"
    [serviceItems]="serviceItems$ | async"
    [companySettings]="companySettings$ | async"
    [userInfo]="userInfo$ | async"
    [directReports]="directReports$ | async"
    [userWebColors]="userWebColors$ | async"
    [selectedError]="selectedErrorWithStatus$ | async"
    [RequestStatusSelectItems]="requestStatusSelectItems$ | async"
    (Save)="onSave($event)"
    (Approve)="onApprove($event)"
    (Unapprove)="onUnapprove($event)"
    (Disapprove)="onDisapprove($event)"
    (Delete)="onDelete($event)"
    (SetRole)="onSetRole($event)"
    (SetDateRange)="onSetDateRange($event)"
    (ShowError)="onShowError($event)"
></ef-leave-request>
